"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normScenario = normScenario;
exports.normPresentationBlocks = normPresentationBlocks;

var _constants = require("../constants");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function normZoneList(zoneList, mapId) {
  return zoneList.reduce(function (result, zone) {
    zone.mapId = mapId;
    result.zoneList[zone.id] = zone;
    return result;
  }, {
    zoneList: {}
  });
}

function normScenario(_ref) {
  var mapList = _ref.mapList,
      ppExerciseList = _ref.ppExerciseList,
      ppSlideList = _ref.ppSlideList,
      scenarioInfo = _objectWithoutProperties(_ref, ["mapList", "ppExerciseList", "ppSlideList"]);

  var _mapList$reduce = mapList.reduce(function (result, map) {
    var zoneList = map.zoneList,
        mapInfo = _objectWithoutProperties(map, ["zoneList"]);

    result.mapList[mapInfo.id] = mapInfo;

    var _normZoneList = normZoneList(zoneList, mapInfo.id),
        newZoneList = _normZoneList.zoneList;

    result.zoneList = _objectSpread({}, result.zoneList, newZoneList);
    return result;
  }, {
    mapList: {},
    zoneList: {}
  }),
      normalizedMapList = _mapList$reduce.mapList,
      normalizedZoneList = _mapList$reduce.zoneList;

  var presentationBlocks = normPresentationBlocks(ppExerciseList, ppSlideList);
  return {
    mapList: normalizedMapList,
    presentationBlocks: presentationBlocks,
    scenarioInfo: scenarioInfo,
    zoneList: normalizedZoneList
  };
}

function normPresentationBlocks() {
  var ppExerciseList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ppSlideList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var exerciseBlocks = Object.values(ppExerciseList).reduce(function (sum, exercise) {
    return Object.values(exercise.blockList).reduce(function (result, exerciseBlock) {
      return _objectSpread({}, result, _defineProperty({}, exerciseBlock.id, _objectSpread({}, exerciseBlock, {
        exerciseId: exercise.exerciseId,
        presentationBlockType: _constants.PRESENTATION_BLOCK_TYPE.EXERCISE_BLOCK,
        stageNumber: exercise.stageNumber
      })));
    }, _objectSpread({}, sum));
  }, {});
  var slideBlocks = Object.values(ppSlideList).reduce(function (result, slideBlock) {
    return _objectSpread({}, result, _defineProperty({}, slideBlock.id, _objectSpread({}, slideBlock, {
      //  Для выбора контейнера на игровом для блока слайдов
      blockCode: 'SlideBlock',
      presentationBlockType: _constants.PRESENTATION_BLOCK_TYPE.SLIDE_BLOCK
    })));
  }, {});
  return _objectSpread({}, exerciseBlocks, slideBlocks);
}